var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('router-link',{staticClass:"sdl",attrs:{"to":"/Professeur"}},[_c('img',{attrs:{"src":require("../../assets/Studio des langues.svg")}})]),_c('img',{staticClass:"user",attrs:{"src":require("../../assets/user.png")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }